import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Input } from "../../../../../common/Input";
import { formatDateLong } from "../../../../../utils/textUtils";
import { FEATURES } from "../../../../../config/features";

const DTRWithOTAddEditModal = ({ isOpen, onClose, selectedItem, onSave }) => {
  const [overtimeValue, setOvertimeValue] = useState(0);

  useEffect(() => {
    if (selectedItem) {
      setOvertimeValue(selectedItem.otHours || 0);
    }
  }, [selectedItem, isOpen]);

  if (!isOpen) return null;
  if (!FEATURES.ALLOW_OT_EDIT_APPROVE) return null;

  return (
    <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3">
      <div className="bg-white w-full md:w-[400px] rounded-lg shadow-xl flex flex-col">
        <div className="flex justify-between items-center px-6 py-4 border-b bg-gray-50 rounded-t-lg">
          <h2 className="text-lg font-bold text-gray-800">Edit Overtime</h2>
          <button onClick={onClose} className="bg-transparent border-none cursor-pointer text-gray-500 hover:text-black">
            <CloseIcon />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <div className="bg-blue-50 p-3 rounded border border-blue-100">
            <p className="text-sm text-blue-800 font-semibold">{selectedItem?.employeePersonalInformationFullName}</p>
            <p className="text-xs text-blue-600">{formatDateLong(selectedItem?.date)}</p>
          </div>

          <Input
            label="Adjusted Overtime Value (Max 2 Decimals)"
            type="number"
            step="0.01"
            value={overtimeValue}
            onChange={(e) => setOvertimeValue(e.target.value)}
            placeholder="0.00"
          />

          <p className="text-[10px] text-gray-400 italic">
            *This value will override the system calculated OT for this day.
          </p>
        </div>

        <div className="flex justify-end space-x-2 p-4 border-t bg-gray-50 rounded-b-lg">
          <button onClick={onClose} className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded border-none cursor-pointer transition-colors">
            Cancel
          </button>
          <button
            onClick={() => onSave({
              employeePersonalInformationId: selectedItem.id, // Using 'id' from your resultList
              timeEntryDate: selectedItem.date,
              overtimeValue: parseFloat(overtimeValue)
            })}
            className="px-6 py-2 text-white bg-blue-600 hover:bg-blue-700 rounded border-none cursor-pointer shadow-md transition-colors">
            Save Override
          </button>
        </div>
      </div>
    </div>
  );
};

export default DTRWithOTAddEditModal;